module.exports = __webpack_public_path__ + "static/media/9_Clubs.267dd350.svg";